import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#e40001',
    pc: {
        background: '/features/rcp-20261109/pc_bg.jpg',
        overlay: 'rgba(95, 0, 0, 0.85)',
        eyebrow: '求人特集',
        titleLines: ['株式会社', 'RCP'],
        contentsColor: '#e40001',
    },
    hero: {
        image: '/features/rcp-20261109/hero.jpg',
        alt: '株式会社RCP 求人特集 都内の人気店『赤から』で 店長候補・スタッフ募集！',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: '「日本で一番' },
            { text: '“従業員が幸せ”', accent: true, breakBefore: true },
            { text: 'な' },
            { text: '飲食企業になる」', breakBefore: true, hangEnd: true },
        ],
        paragraphs: [
            { text: '人生の中で多くの時間と労力を費やす' },
            { text: '「仕事」だからこそ、', breakBefore: true },
            { text: '当社では従業員としての', breakBefore: true },
            { text: '幸せ感を大切にしています。', breakBefore: true },
        ],
    },
    thumbnail: {
        image: '/features/rcp-20261109/top_sub.jpg',
        alt: '笑顔で働くスタッフ、チーズをのせた鍋料理、カウンター席の写真',
    },
    featuresTitle: ['RCPで働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: [
                '安心して長く働ける環境を、',
                '今もこれからもつくっていく',
            ],
            body: [
                '公休も月9日を確保し、有給休暇の取得日数は平均10日以上（2025年度実績）。しっかり休みながら働ける環境を整えています。',
            ],
            image: '/features/rcp-20261109/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['一つの店舗を、', '一つの会社のように'],
            body: [
                '当社では、現場で働く社員一人ひとりに大きな裁量を与えています。「一つの店舗を一つの会社のように考えてほしい」という想いのもと、各店舗で売上・損益をしっかりと出し、目標に対してどう達成していくかをみんなで考えながら店舗運営をおこなっています。',
            ],
            image: '/features/rcp-20261109/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['全国トップクラスの', '『赤から』として'],
            body: [
                '当社の『赤から』は、いずれの店舗も好立地に恵まれており、全国的に見ても売上はトップクラス！多くのお客様に愛される店舗として成長を続けています。',
            ],
            image: '/features/rcp-20261109/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    jobs: {
        eyebrow: 'pickup',
        title: ['RCP 求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'manager',
                categoryLabel: '店長・店長候補',
                variant: 'carousel',
                description:
                    '家族手当・住宅手当・役職者手当などの各種手当に加え、店長職には毎月インセンティブのチャンスもあり、頑張りが給与に反映される仕組みです。',
                jobs: [
                    {
                        offerId: '122884',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: '《抜群の労働環境✨腰を据えてキャリアを積めます！》赤からの店長候補を募集',
                        brandName: '赤から 上野駅前店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '台東区',
                        image: '/features/rcp-20261109/job_card_01_01.jpg',
                        href: 'https://foods-labo.com/offers/122884',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-1st',
                    },
                    {
                        offerId: '122959',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: '《充実の福利厚生で長期活躍できる環境です🌟》赤からの店長候補を募集中！',
                        brandName: '赤から 新宿靖国通り店はなれ',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_01_02.jpg',
                        href: 'https://foods-labo.com/offers/122959',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-2nd',
                    },
                    {
                        offerId: '122964',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: '《面接1回＊転居なし》スキルを活かして長期活躍できる環境🌟￤店長候補',
                        brandName: '赤から 新宿東口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_01_03.jpg',
                        href: 'https://foods-labo.com/offers/122964',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-3rd',
                    },
                    {
                        offerId: '122969',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: '人気ブランド『赤から』の店長候補募集✨アクセス良好＊転居なし＊福利厚生充実',
                        brandName: '赤から 歌舞伎町店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_01_04.jpg',
                        href: 'https://foods-labo.com/offers/122969',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-4th',
                    },
                    {
                        offerId: '122973',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: '＜店長候補を募集＞長期活躍できる環境であなたの挑戦をサポートします🌟',
                        brandName: '赤から 下北沢店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '世田谷区',
                        image: '/features/rcp-20261109/job_card_01_05.jpg',
                        href: 'https://foods-labo.com/offers/122973',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-5th',
                    },
                    {
                        offerId: '122992',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: 'キャリア充実＊各種手当あり＊月9休み￤『赤から』FC店舗の店長候補を募集✨',
                        brandName: '赤から TBS通り店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/rcp-20261109/job_card_01_06.jpg',
                        href: 'https://foods-labo.com/offers/122992',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-6th',
                    },
                    {
                        offerId: '122997',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: '《キャリア充実＊面接1回》安定基盤で腰を据えて働ける店長候補を募集中！',
                        brandName: '赤から 吉祥寺北口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '武蔵野市',
                        image: '/features/rcp-20261109/job_card_01_07.jpg',
                        href: 'https://foods-labo.com/offers/122997',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-7th',
                    },
                    {
                        offerId: '123006',
                        badgeLabel: '居酒屋｜店長・店長候補',
                        title: '《抜群の労働環境＊面接1回＊転居なし》店長候補としてキャリアを築けます！',
                        brandName: '赤から 赤羽店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '31~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '北区',
                        image: '/features/rcp-20261109/job_card_01_08.jpg',
                        href: 'https://foods-labo.com/offers/123006',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-店長・店長候補-8th',
                    },
                ],
            },
            {
                id: 'kitchen',
                categoryLabel: 'キッチンスタッフ',
                variant: 'carousel',
                description:
                    '赤から鍋や手羽先唐揚げ、味噌串カツなど、名古屋発の名物料理を提供。メニューは直営元からしっかりと規格化されています。',
                jobs: [
                    {
                        offerId: '122887',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '《キャリア充実＊労働環境安定》人気ブランド『赤から』の社員スタッフを募集！',
                        brandName: '赤から 上野駅前店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '台東区',
                        image: '/features/rcp-20261109/job_card_02_01.jpg',
                        href: 'https://foods-labo.com/offers/122887',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-1st',
                    },
                    {
                        offerId: '122962',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '《正社員募集🌸経験浅くても◎🌸研修制度充実》赤からで社員スタッフ募集！',
                        brandName: '赤から 新宿靖国通り店はなれ',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_02_02.jpg',
                        href: 'https://foods-labo.com/offers/122962',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-2nd',
                    },
                    {
                        offerId: '122967',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '＜福利厚生◎＊アクセス良好＞初めての正社員でもOK￤人気ブランド『赤から』',
                        brandName: '赤から 新宿東口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_02_03.jpg',
                        href: 'https://foods-labo.com/offers/122967',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-3rd',
                    },
                    {
                        offerId: '122971',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '＜各種手当充実＊転居なし＊未経験OK＞赤からFC店舗の社員スタッフを募集！',
                        brandName: '赤から 歌舞伎町店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_02_04.jpg',
                        href: 'https://foods-labo.com/offers/122971',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-4th',
                    },
                    {
                        offerId: '122989',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '抜群の労働環境＊キャリア充実￤人気ブランド『赤から』の社員スタッフ募集🌸',
                        brandName: '赤から 下北沢店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '世田谷区',
                        image: '/features/rcp-20261109/job_card_02_05.jpg',
                        href: 'https://foods-labo.com/offers/122989',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-5th',
                    },
                    {
                        offerId: '122995',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '《アクセス良好＊未経験歓迎＊研修充実》挑戦したい気持ちをサポートします✨',
                        brandName: '赤から TBS通り店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/rcp-20261109/job_card_02_06.jpg',
                        href: 'https://foods-labo.com/offers/122995',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-6th',
                    },
                    {
                        offerId: '122999',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '【研修制度充実＊アクセス◎＊面接1回】赤からの正社員スタッフを募集します！',
                        brandName: '赤から 吉祥寺北口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '武蔵野市',
                        image: '/features/rcp-20261109/job_card_02_07.jpg',
                        href: 'https://foods-labo.com/offers/122999',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-7th',
                    },
                    {
                        offerId: '123008',
                        badgeLabel: '居酒屋｜キッチンスタッフ',
                        title: '《労働環境抜群で安定して長く働ける》赤からの正社員スタッフを積極採用中🌟',
                        brandName: '赤から 赤羽店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '北区',
                        image: '/features/rcp-20261109/job_card_02_08.jpg',
                        href: 'https://foods-labo.com/offers/123008',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ-8th',
                    },
                ],
            },
            {
                id: 'hall',
                categoryLabel: 'ホールスタッフ',
                variant: 'carousel',
                description:
                    '若年層からファミリー層まで、幅広いお客様が訪れるカジュアルな店内。トレーナーもつくので、経験の浅い方でも安心です。',
                jobs: [
                    {
                        offerId: '122886',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【赤からの正社員募集｜アクセス良好】月9休み＊福利厚生◎＊充実した研修制度',
                        brandName: '赤から 上野駅前店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '台東区',
                        image: '/features/rcp-20261109/job_card_03_01.jpg',
                        href: 'https://foods-labo.com/offers/122886',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-1st',
                    },
                    {
                        offerId: '122961',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【面接1回＊福利厚生◎＊月9休】人気ブランド「赤から」の店舗スタッフを募集',
                        brandName: '赤から 新宿靖国通り店はなれ',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_03_02.jpg',
                        href: 'https://foods-labo.com/offers/122961',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-2nd',
                    },
                    {
                        offerId: '122966',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【正社員募集＊研修制度充実＊未経験OK】赤からFC店舗でスタッフを募集✨',
                        brandName: '赤から 新宿東口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_03_03.jpg',
                        href: 'https://foods-labo.com/offers/122966',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-3rd',
                    },
                    {
                        offerId: '122970',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【キャリアUP＊面接1回＊月9日休み】福利厚生充実で長期活躍できる環境◎',
                        brandName: '赤から 歌舞伎町店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_03_04.jpg',
                        href: 'https://foods-labo.com/offers/122970',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-4th',
                    },
                    {
                        offerId: '122988',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【未経験OK＊研修充実＊面接1回】幅広い世代が活躍中です✨人間関係良好◎',
                        brandName: '赤から 下北沢店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '世田谷区',
                        image: '/features/rcp-20261109/job_card_03_05.jpg',
                        href: 'https://foods-labo.com/offers/122988',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-5th',
                    },
                    {
                        offerId: '122994',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【腰を据えてキャリアを積めます！】労働環境抜群で長期活躍が叶う🌟月9休み',
                        brandName: '赤から TBS通り店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/rcp-20261109/job_card_03_06.jpg',
                        href: 'https://foods-labo.com/offers/122994',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-6th',
                    },
                    {
                        offerId: '122998',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【キャリアアップ目指せます✨労働環境◎】赤からFC店舗で店舗STAFF募集',
                        brandName: '赤から 吉祥寺北口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '武蔵野市',
                        image: '/features/rcp-20261109/job_card_03_07.jpg',
                        href: 'https://foods-labo.com/offers/122998',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-7th',
                    },
                    {
                        offerId: '123007',
                        badgeLabel:
                            '居酒屋｜レストランサービス・ホールスタッフ',
                        title: '【赤からで長期活躍できる社員を募集✨】人間関係良好＊研修制度充実＊月9休み',
                        brandName: '赤から 赤羽店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '北区',
                        image: '/features/rcp-20261109/job_card_03_08.jpg',
                        href: 'https://foods-labo.com/offers/123007',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-ホールスタッフ-8th',
                    },
                ],
            },
            {
                id: 'assistant',
                categoryLabel: '調理見習い・調理補助',
                variant: 'carousel',
                description:
                    '若手スタッフや、飲食業界未経験の方も歓迎。既存店舗でのOJTを通じて、10〜14日程度で基本業務を覚えていけます。',
                jobs: [
                    {
                        offerId: '122888',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '【若手スタッフ募集】飲食未経験OK＊月9日休み＊人間関係良し＊福利厚生充実',
                        brandName: '赤から 上野駅前店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '台東区',
                        image: '/features/rcp-20261109/job_card_04_01.jpg',
                        href: 'https://foods-labo.com/offers/122888',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-1st',
                    },
                    {
                        offerId: '122963',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '【未経験歓迎＊初めての正社員OK】充実の環境であなたの挑戦をサポートします',
                        brandName: '赤から 新宿靖国通り店はなれ',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_04_02.jpg',
                        href: 'https://foods-labo.com/offers/122963',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-2nd',
                    },
                    {
                        offerId: '122968',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '【研修制度充実＊面接1回＊未経験歓迎】『赤から』の若手社員スタッフを募集！',
                        brandName: '赤から 新宿東口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_04_03.jpg',
                        href: 'https://foods-labo.com/offers/122968',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-3rd',
                    },
                    {
                        offerId: '122972',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '《賞与2回＊研修充実＊人間関係良好》未経験からキャリアアップ目指せます✨',
                        brandName: '赤から 歌舞伎町店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '新宿区',
                        image: '/features/rcp-20261109/job_card_04_04.jpg',
                        href: 'https://foods-labo.com/offers/122972',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-4th',
                    },
                    {
                        offerId: '122990',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '《若手STAFF募集》月9休み＊労働環境安定＊福利厚生充実￤赤からFC店舗',
                        brandName: '赤から 下北沢店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '世田谷区',
                        image: '/features/rcp-20261109/job_card_04_05.jpg',
                        href: 'https://foods-labo.com/offers/122990',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-5th',
                    },
                    {
                        offerId: '122996',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '「赤から」で若手STAFFを募集🌸飲食未経験OK＊研修充実＊賞与2回',
                        brandName: '赤から TBS通り店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '港区',
                        image: '/features/rcp-20261109/job_card_04_06.jpg',
                        href: 'https://foods-labo.com/offers/122996',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-6th',
                    },
                    {
                        offerId: '123005',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '《若手社員＊未経験歓迎》人気ブランド『赤から』で働きませんか？／月9休み',
                        brandName: '赤から 吉祥寺北口店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '武蔵野市',
                        image: '/features/rcp-20261109/job_card_04_07.jpg',
                        href: 'https://foods-labo.com/offers/123005',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-7th',
                    },
                    {
                        offerId: '123009',
                        badgeLabel: '居酒屋｜調理見習い・調理補助',
                        title: '【正社員募集＊研修充実】人気ブランド『赤から』で若手スタッフを募集！',
                        brandName: '赤から 赤羽店',
                        brandLogo: '/features/rcp-20261109/logo_01.jpg',
                        salary: '28~33',
                        salaryUnit: '月収',
                        prefecture: '東京都',
                        city: '北区',
                        image: '/features/rcp-20261109/job_card_04_08.jpg',
                        href: 'https://foods-labo.com/offers/123009',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理見習い・調理補助-8th',
                    },
                ],
            },
        ],
    },
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
}
